import React, { FC, memo } from 'react'
import { FeatureIcon, FeatureIconWrapper, FeatureLabel, FeaturesContainer, FeatureWrapper } from './features-styles'
import IconMapping from '../../property-details/icon-mapping'
import { AnyStyledComponent } from 'styled-components'
import { Features as FeaturesTransport } from '../../../models/common/features-model'
import isEmpty from 'lodash/isEmpty'
import { Typography } from 'react-components'

type FeaturesProps = {
    features: FeaturesTransport | null
    color: string
    size: number
    gap: number
    visibleFeatures: number
    showLabel?: boolean
}

const InlineFeatures: FC<FeaturesProps> = ({ features, color, size, gap, visibleFeatures, showLabel = false }) => {
    if (!features || isEmpty(features)) {
        return null
    }

    const orderedFeatureKeys = Object.keys(IconMapping).filter(iconId => features[iconId])
    const visibleKeys = orderedFeatureKeys.slice(0, visibleFeatures)
    const remainingCount = orderedFeatureKeys.length - visibleKeys.length

    return (
        <FeaturesContainer gap={gap}>
            {visibleKeys.map(iconId => {
                const feature = features[iconId]
                const IconComponent = IconMapping[iconId] as AnyStyledComponent
                if (!IconComponent || !feature) {
                    return null
                }

                return (
                    <FeatureWrapper key={iconId}>
                        <FeatureIconWrapper state={feature.state} color={color} size={size}>
                            <FeatureIcon as={IconComponent} color={color} size={size} />
                        </FeatureIconWrapper>
                        {showLabel && feature.label && <FeatureLabel>{feature.label}</FeatureLabel>}
                    </FeatureWrapper>
                )
            })}

            {remainingCount > 0 && (
                <FeatureWrapper key="more-count">
                    <Typography variant="overline" color="tfwBlack40">
                        +{remainingCount}
                    </Typography>
                </FeatureWrapper>
            )}
        </FeaturesContainer>
    )
}

export default memo(InlineFeatures)
